export default __webpack_public_path__ + "static/media/Correct Guess.6498b192.mp3";